module.exports = __webpack_public_path__ + "assets/retina_EquilateralByCentroid2PDetailed.34c1abbf81070b355731e41ad29b27fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_EquilateralByCentroid2PDetailed.png
// module id = 664
// module chunks = 0